import { ApolloQuery, html } from '@apollo-elements/lit-apollo';
import { injectGlobal, } from 'emotion';
import GetRegion from './region.graphql';
import { backgroundStyle, cardStyle, } from './page-region.style';
import '../../components/icon/icon-info';
import '../../components/icon/icon-store';
import '../../components/icon/icon-star';
import '../../components/icon/icon-arrow-down';
import '../../components/icon/icon-location';

export class PageRegion extends ApolloQuery {
  static get properties() {
    return {
      hideMoreButton__restArea: { type: Boolean, },
      hideMoreButton__tourList: { type: Boolean, },
    };
  }

  query = GetRegion;
  variables = { 
    id: ``,
    location: {
      latitude: localStorage.getItem(`latitude`) || null,
      longitude: localStorage.getItem(`longitude`) || null,
    },    
    restLimit: 5,
    restOffset: 0,
    tourLimit: 5,
    tourOffset: 0,
  };

  createRenderRoot() {
    return this;
  }
  
  connectedCallback() {       
    if (!localStorage.getItem(`latitude`) && !localStorage.getItem(`longitude`)) {
      this.variables.location = null;
    } else {
      this.variables.location = {
        latitude: localStorage.getItem(`latitude`) || null,
        longitude: localStorage.getItem(`longitude`) || null,
      };
    }   
    this.variables.id = window.app.views.main.router.currentRoute.params.id || ``; 

    this.map = null;
    this.hideMoreButton__restArea = false;
    this.hideMoreButton__tourList = false;
    super.connectedCallback();
  }

  shouldUpdate() {
    return (
      this.variables.id != null ||
      this.loading != null ||
      this.data ||
      this.error
    );
  }  
  
  render() {
    if (!this.data) {
      return html`
      loading... 
      `;
    }

    if (this.error) {
      console.error(this.error);
      return html`
      loading...
      `;
    }

    if (this.loading) {
      return html`
      loading...
      `;
    }    

    this.updateComplete.then(() => {
      this.createMap();
    });

    if (this.data.zone.restAreaList.count === this.data.zone.restAreaList.restAreas.length) {
      this.hideMoreButton__restArea = true;
    }

    if (this.data.zone.tourList.count === this.data.zone.tourList.tours.length) {
      this.hideMoreButton__tourList = true;
    }

    return html`
    <div class="${backgroundStyle(this.data.zone.image)}">
      <div class="background">
        <h1 class="region-title">${this.data.zone.name}</h1>
      </div>

      <section class="tab">
        <h2 class="tab-title"><icon-info active></icon-info>지역 정보</h2>
        <div id="map">

        </div>
      </section>

      <section class="tab">
        <h2 class="tab-title rest-area"><icon-store active></icon-store>지역 내 휴게소 목록</h2>

        <ul class="rest-area-list">
          ${this.data.zone.restAreaList.restAreas.map(each => this.restAreaCard(each))}
          <div class="more ${this.hideMoreButton__restArea ? `hide`: ``}"
            @click=${this.onClickMoreButton}
          >
            <icon-arrow-down></icon-arrow-down>
            더보기
          </div>  
        </ul>
      </section>

      <section class="tab">
        <h2 class="tab-title region"><icon-location width="30" height="30" active></icon-location>관광 정보 목록</h2>

        <ul class="rest-area-list">
          ${this.data.zone.tourList.tours.map(each => this.tourCard(each))}
          <div class="more region-more ${this.hideMoreButton__tourList ? `hide`: ``}"
            @click=${this.onClickMoreTourList}
          >
            <icon-arrow-down></icon-arrow-down>
            더보기
          </div>  
        </ul>
      </section>
    </div>
    `;
  }

  restAreaCard(data = {
    imgUrl: `http://tong.visitkorea.or.kr/cms/resource/44/2481544_image2_1.jpg`,
    name: `휴게소`,
    direction: ``,
    distance: 1000,
    score: 4.5,
  }) {
    return html`
      <li class="card rest-area-card ${cardStyle(data.imgUrl)}"
        @click=${() => window.app.views.main.router.navigate(`/rest-area/${data.id}`)}
      >
        <!-- <div class="img"></div> -->
        <h3>
          <span>${data.name} ${data.direction && `(${data.direction})`}</span>
          <span class="score-wrap">
            <icon-star active></icon-star>
            <span>${data.score}</span>
          </span>
        </h3>
        <h4>현재 위치로부터 ${(data.distance / 1000)?.toFixed(2)}km</h4>
      </li>
    `;
  }

  tourCard(data = {
    image: `http://tong.visitkorea.or.kr/cms/resource/44/2481544_image2_1.jpg`,
    title: `관광`,
    desc: `설명`,
    homePage,
  }) {
    return html`
      <li class="card region-card ${cardStyle(data.image)}"
        @click=${() => this.onClickRegion(data)}
      >
        ${data.image ? html`<div class="img"></div>` : null}
        <h3>
          <span>${data.title}</span>          
        </h3>
        <h4>${data.desc}</h4>
      </li>
    `;
  }

  // Event - Start
  
  onClickMoreButton() {
    this.variables.restOffset += 1;
    this.fetchMore({
      variables: this.variables,
      updateQuery: (prev, { fetchMoreResult }) => {
        if (fetchMoreResult.zone.restAreaList.count === prev.zone.restAreaList.restAreas.length) {          
          this.hideMoreButton__restArea = true;
          return prev;
        }
        fetchMoreResult.zone.restAreaList.restAreas = [...prev.zone.restAreaList.restAreas, ...fetchMoreResult.zone.restAreaList.restAreas];
        return fetchMoreResult;
      }
    });
  }

  onClickRegion(data) {
    if (!data.homePage) {
      return;
    }

    cordova.InAppBrowser.open(data.homePage, `_blank`);
  }

  async onClickMoreTourList() {  
    this.variables.tourOffset += 1;
    await this.fetchMore({
      variables: this.variables,
      updateQuery: (prev, { fetchMoreResult }) => {
        if (fetchMoreResult.zone.tourList.count === fetchMoreResult.zone.tourList.tours.length) {
          this.hideMoreButton__tourList = true;
          return prev;
        }
        fetchMoreResult.zone.tourList.tours = [...prev.zone.tourList.tours, ...fetchMoreResult.zone.tourList.tours];
        return fetchMoreResult;
      }
    });
  }
  // --- Event - End
  // Custom Function

  createMap() {
    if (this.map) {
      return;
    }

    const mapContainer = this.querySelector('#map');
    const regionMapLevel = this.data?.zone.name === `서울특별시` 
    || this.data?.zone.name === `인천광역시`
    || this.data?.zone.name === `광주광역시`    
    || this.data?.zone.name === `대전광역시`
    || this.data?.zone.name === `제주도`
    ? 10
    : this.data?.zone.name === `울산광역시`
    || this.data?.zone.name === `부산광역시`
    || this.data?.zone.name === `대구광역시`
    ? 12
    : 16;
    const mapOption = { 
      center: new kakao.maps.LatLng(this.data?.zone.loc.coordinates[1], this.data?.zone.loc.coordinates[0]),
      level: regionMapLevel,
    };    

    this.map = new kakao.maps.Map(mapContainer, mapOption);    
    this.map.setZoomable(false);
    this.map.setDraggable(false);
    const polygonPath = this.data?.zone.polygon?.coordinates[0].map(each => new kakao.maps.LatLng(each[1], each[0]));
    
    const polygon = new kakao.maps.Polygon({
      path: polygonPath,
      strokeWeight: 1,
      strokeColor: '#cea36b',
      strokeOpacity: 0.8,
      strokeStyle: 'solid',
      fillColor: '#bea36b',
      fillOpacity: 0.7,
    });

    polygon.setMap(this.map);

    const mouseoverOption = { 
      fillColor: '#aea36b',
      fillOpacity: 0.8,
    };

    const mouseoutOption = {
      fillColor: '#bea36b',
      fillOpacity: 0.7,
    };

    const downCount = 0;

    kakao.maps.event.addListener(polygon, 'mouseover', () => { 
      polygon.setOptions(mouseoverOption);
    });   

    kakao.maps.event.addListener(polygon, 'mouseout', () => { 
      polygon.setOptions(mouseoutOption);
    }); 
  }

  // --- Custom Function - End
}

injectGlobal`
page-region {
  display: contents;
}
`;

customElements.define('page-region', PageRegion);